// src/api/authApi.ts
 
import { User } from "../types/user";
import api from "./api"; 

interface LoginResponse {
  user: User;
  accessToken: string;
  refreshToken: string;
}

export const loginRequest = async (email: string, password: string, firmId?: number | null): Promise<LoginResponse> => {
  const payload: any = { email, password };
  if (firmId) {
    payload.firmId = firmId;
  }
  const res = await api.post("/auth/login", payload);
  console.log(res)
  return res.data;
};

export const logoutRequest = async (refreshToken: string ): Promise<LoginResponse> => {
  const res = await api.post("/auth/logout", { refreshToken });
  return res.data;
};
